module.exports = __webpack_public_path__ + "img/Ergotherapeut_05_FM.44ce058a.jpg";